module.exports = __webpack_public_path__ + "img/81.c566cac2.png";